export default __webpack_public_path__ + "static/media/goodstuff.740b18f6.webp";